export const initPortfolioPreview = () => {
	const root = document.querySelector(".portfolio-preview");
	const slider = root?.querySelector(".portfolio-preview__slider");

	if (!root || !slider || typeof Swiper === "undefined") {
		return;
	}

	if (slider.swiper) {
		slider.swiper.destroy(true, true);
	}

	const slides = Array.from(slider.querySelectorAll(".portfolio-preview__slide"));
	const canHover =
		window.matchMedia("(hover: hover) and (pointer: fine)").matches;

	const clearActive = (except = null) => {
		slides.forEach((slide) => {
			if (slide !== except) {
				slide.classList.remove("is-active");
			}
		});
	};

	const swiper = new Swiper(slider, {
		slidesPerView: "auto",
		spaceBetween: 25,
		centeredSlides: false,
		loop: slides.length > 3,
		loopAdditionalSlides: Math.min(slides.length, 4),
		speed: 600,
		grabCursor: true,
		allowTouchMove: true,
		simulateTouch: true,
		watchOverflow: false,
		resistanceRatio: 0,
		observer: true,
		observeParents: true,
		on: {
			touchStart(instance) {
				instance.__ppStartTranslate = instance.getTranslate();
			},
			sliderMove(instance) {
				// Только вперёд: к слайдам справа (translate уменьшается).
				// Движение влево (назад) блокируем.
				const start = instance.__ppStartTranslate;
				const current = instance.getTranslate();

				if (typeof start === "number" && current > start) {
					instance.setTranslate(start);
					instance.updateProgress();
				}
			},
			touchEnd(instance) {
				const start = instance.__ppStartTranslate;
				const current = instance.getTranslate();

				if (typeof start === "number" && current > start) {
					instance.setTranslate(start);
					instance.updateProgress();
				}

				instance.__ppStartTranslate = undefined;
			},
		},
	});

	if (canHover) {
		return;
	}

	let pointerStartX = 0;
	let pointerStartY = 0;
	let moved = false;

	slides.forEach((slide) => {
		slide.addEventListener(
			"pointerdown",
			(event) => {
				pointerStartX = event.clientX;
				pointerStartY = event.clientY;
				moved = false;
			},
			{ passive: true }
		);

		slide.addEventListener(
			"pointermove",
			(event) => {
				if (
					Math.abs(event.clientX - pointerStartX) > 8 ||
					Math.abs(event.clientY - pointerStartY) > 8
				) {
					moved = true;
				}
			},
			{ passive: true }
		);

		slide.addEventListener("pointerup", () => {
			if (moved) {
				return;
			}

			const willActivate = !slide.classList.contains("is-active");
			clearActive();

			if (willActivate) {
				slide.classList.add("is-active");
			}
		});
	});

	document.addEventListener("pointerdown", (event) => {
		if (!root.contains(event.target)) {
			clearActive();
		}
	});

	return swiper;
};
